import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpHeaderResponse, HttpClientModule } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Organization, StateList, StorageUtil } from '../store';
import { HttpService } from './http.service';
import { ClubUniformUpdate } from '../interfaces/club-uniform-update';
import { NotificationsService, NotificationType } from 'angular2-notifications';

@Injectable()
export class MyTeamsService {

  private _links = [];
  private _mainLink = { title: 'MyTeams', url: '/my-teams' };

  private _api = '/api/team';
  private _apiClubProgram = '/api/clubProgram';
  private _apiPlayer = '/api/player';
  private _apiCollegeScope = '/api/CollegeScope';
  private _apiClubParent = '/api/clubParent';
  private _apiUrl = '/api/CollegeRecruitingCenter';
  private _apiEvent = '/api/event';
  private _clubUrl = '/api/Club';
  private _apiURLMobile = '/api/Mobile';
  private _apiMasterBackend = '/api/TGSMasterBackend';
  private _apiGame = '/api/Game';
  links: { title: string; url: any; }[];

  constructor(
    private http: HttpClient,
    private httpService: HttpService,
    private notifyService: NotificationsService
  ) { }

  getById(teamID: number) {
    return this.httpService.get(this._api + `/team-by-id/${teamID}`);
  }

  getMarketingPopupForStaffLogin(accountTypeID: number, id: number) {
    return this.httpService.get(`${this._apiMasterBackend}/get-marketing-popup-for-staff-login/${accountTypeID}/${id}`);
  }

  //My Teams Page
  getAdminTeamList(userID: number, roleID: number) {
    return this.httpService.get(`${this._api}/get-my-teams-by-team-admin/${userID}/${roleID}`);
  }

  getAdminTeamClubData(teamID: number) {
    return this.httpService.get(`${this._apiClubProgram}/get-club-info-by-team/${teamID}`);
  }

  getCountryList() {
    return this.httpService.get(`${this._apiClubProgram}/get-country-list`);
  }

  getStateListByCountry(countryID: number) {
    return this.httpService.get(`${this._apiPlayer}/get-all-states-by-countryId/${countryID}`);
  }

  getClubListByState(stateID: number) {
    return this.httpService.get(`${this._api}/get-club-list-by-state/${stateID}`);
  }

  addNewTeam(team: any) {
    return this.httpService.post(this._api + `/add-new-team`, team);
  }

  addNewTeamPublic(team: any) {
    return this.httpService.post(this._api + `/add-new-team-public`, team);
  }

  removeTeams(userID: number, userRoleID: number, teamIDs: string) {
    return this.httpService.delete(`${this._api}/remove-teams/${userID}/${userRoleID}/${teamIDs}`);
  }
  //END My Teams Page


  //My Team - Dashboard
  getDashboardTopCounts(teamID: number) {
    return this.httpService.get(`${this._api}/get-dashboard-top-counts/${teamID}`);
  }

  getNextUpcomingGames(teamID: number) {
    return this.httpService.get(`${this._api}/get-next-upcoming-games/${teamID}`);
  }

  printMatchReport(teamID: number, eventID: number, matchID: number) {
    return this.httpService.postRaw(this._api + `/print-team-match-report/${teamID}/${eventID}/${matchID}`);
  }

  printEventRosters(data: any) {
    return this.httpService.postRaw(this._api + `/print-team-event-rosters`, data);
  }

  printTeamStatisticsViewMatchReport(teamID: number, eventID: number, matchID: number) {
    return this.httpService.postRaw(this._api + `/print-team-statistics-match-report/${teamID}/${eventID}/${matchID}`);
  }

  //END My Team - Dashboard

  //My Messages
  getMyMessageLeftNavCounts(userID: number, teamID: number) {
    return this.httpService.get(this._api + '/get-my-message-left-nav-counts/' + userID + '/' + teamID);
  }
  getMessagesForTeamAdmin(userID: number, teamID: number) {
    return this.httpService.get(this._api + '/get-recieved-messages-for-team-admin/' + userID + '/' + teamID);
  }
  getSentMessageForTeamAdmin(userID: number, teamID: number) {
    return this.httpService.get(this._api + '/get-sent-messages-for-team-admin/' + userID + '/' + teamID);
  }
  updateUnreadMessageListToRead(messageIDList) {
    return this.httpService.post(`${this._apiPlayer}/update-unread-message-list-to-read`, messageIDList);
  }
  deleteMessagesByMessageIDList(messageIDListObj) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      }),
      body: {
        MessageIDList: messageIDListObj.MessageIDList,
        CoachID: messageIDListObj.CoachID
      }
    };
    return this.http.delete(this._apiCollegeScope + '/delete-email-by-college-coach', httpOptions);
    // return this.httpService.delete(`${this._apiCollegeScope}/delete-email-by-college-coach`, messageIDListObj);
  }
  updateUnreadMessagesToRead(messageID: number) {
    return this.httpService.post(`${this._apiPlayer}/update-unread-messages-to-read/${messageID}`);
  }
  sendReply(data: any) {
    return this.httpService.post(`${this._apiPlayer}/reply-college-coach`, data);
  }
  //END My Messages

  //END My Team - Dashboard

  // My Team - Event

  getTeamEventTopCounts(teamID: number, teamGender: string) {
    return this.httpService.get(this._api + '/get-team-event-top-counts/' + teamID + '/' + teamGender);
  }
  getTeamEventList(teamID: number, status: number) {
    return this.httpService.get(this._api + '/get-team-event-list/' + teamID + '/' + status);
  }
  getFindTeamEventList(teamID: number, teamGender: string) {
    return this.httpService.get(this._api + '/get-find-team-event-list/' + teamID + '/' + teamGender);
  }
  removeEvents(teamID: number, eventIDs: string) {
    return this.httpService.delete(`${this._api}/remove-event-from-team/${teamID}/${eventIDs}`);
  }
  // END My Team - Event

  // My Team - Players
  checkIsPlayerApprovedInOrgCurrentSeason(teamID: number) {
    return this.httpService.get(this._api + '/check-is-player-approved-in-org-current-season/' + teamID);
  }
  getTeamPlayerListByTeamID(teamID: number) {
    return this.httpService.get(this._apiURLMobile + '/get-team-player-list-by-teamID/' + teamID);
  }
  getPracticeRostersByTeamIDAndPracticeID(teamID: number, practiceID: number) {
    return this.httpService.get(this._api + '/get-practice-rosters-by-teamID-and-practiceID/' + teamID + '/' + practiceID);
  }
  getTeamPlayerList(teamID: number, status: number, userID: number) {
    return this.httpService.get(this._api + '/get-team-player-list/' + teamID + '/' + status + '/' + userID);
  }
  getGaurdianFamilyInfo(playerID: number) {
    return this.httpService.get(this._apiPlayer + '/get-family-info/' + playerID);
  }
  sendEmailToPlayerForActive(data: any, isStaff: boolean) {
    return this.httpService.postRaw(`${this._api}/${isStaff ? 'send-email-to-staff-for-active' : 'send-email-to-player-for-active'}`, data);
  }
  printUsClubRosters(data) {
    return this.httpService.postRaw(`${this._api}/print-us-club-rosters`, data);
  }
  // END My Team - Players

  // My Team Schedules  
  getSchedulesLeftNavCount(teamID: number, userID: number) {
    return this.httpService.get(this._api + '/get-team-schedules-leftnav-count/' + teamID + '/' + userID);
  }
  getTeamScheduleGameDataByTeamID(teamID: number, isUpcoming: boolean) {
    return this.httpService.get(this._api + '/get-team-schedule-game-data-by-teamID/' + teamID + '/' + isUpcoming);
  }
  // getTeamUpcomingTGSGamesInfo(teamID: number, isUpcoming: boolean) {
  //   return this.httpService.get(this._api + '/get-team-schedule-game-data/' + teamID + '/' + isUpcoming);
  // }
  getTeamUpcomingNonTGSGamesInfo(teamID: number, userID: number, isUpcoming: boolean) {
    return this.httpService.get(this._api + '/get-non-tgs-team-schedule-game-data/' + teamID + '/' + userID + '/' + isUpcoming);
  }
  getTeamUpcomingNonTGSGamesInfoNew(teamID: number, isUpcoming: number) {
    return this.httpService.get(this._api + '/get-user-added-games-list-by-team/' + teamID + '/' + isUpcoming);
  }
  // getTeamPastTGSGamesInfo(teamID: number, isUpcoming: boolean) {
  //   return this.httpService.get(this._api + '/get-team-schedule-game-data/' + teamID + '/' + isUpcoming);
  // }
  getPastGamesInfo(teamID: number, userID: number) {
    return this.httpService.get(this._api + '/get-team-past-game-data/' + teamID + '/' + userID);
  }
  getTeamClubJerseyDetail(homeTeamJerseyLogoID: number, awayTeamJerseyLogoID: number) {
    return this.httpService.get(this._api + '/get-team-club-jersey-Detail/' + homeTeamJerseyLogoID + '/' + awayTeamJerseyLogoID);
  }
  saveArrivalTimeForGame(obj: any) {
    return this.httpService.post(this._api + '/save-arrival-time-for-game', obj);
  }
  saveUniformForGame(matchID: number, jerseryLogoID: number, teamFlag: number) {
    return this.httpService.post(this._api + '/save-game-uniform-for-team/' + matchID + '/' + jerseryLogoID + '/' + teamFlag);
  }
  // End My Team Schedules

  updateClubUniforms(clubId: number, payload: ClubUniformUpdate) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.httpService.post(this._api + '/update-club-uniforms/' + clubId, payload, httpOptions);
  }

  // Get Game Direction with Wether data
  getMatchDirectionData(userID: number, complexID: number, venueID: number, gameID: number, zip: string) {
    return this.httpService.get(this._api + '/get-game-complex-venue-weather-info/' + userID + '/' + complexID + '/' + venueID + '/' + gameID + '/' + zip);
  }
  getMapData(address: string) {
    return this.httpService.getRaw('https://maps.googleapis.com/maps/api/geocode/json?address=' + address + '&key=AIzaSyBrSzkQQ11v2hS7rXTT0w4K6axn8SFKfu8');
  }

  // END Get Game Direction with Wether data

  // Add Non TGS Game
  getStatesByCountryID(countryID: number) {
    return this.httpService.get(this._apiPlayer + '/get-all-states-by-countryId/' + countryID);
  }
  getNonTGSEventData(year: number, stateID: number) {
    return this.httpService.get(this._apiPlayer + '/get-events-by-selected-year-and-state/' + year + '/' + stateID);
  }
  saveNonTGSGame(gameDataList: any) {
    return this.httpService.post(this._api + '/add-non-tgs-game-for-teamadmin', gameDataList);
  }
  saveOrUpdateUserAddedGame(gameDataList: any) {
    return this.http.post(this._apiURLMobile + '/save-or-update-user-added-game', gameDataList);
  }
  saveOrUpdateUserAddedGameWithComplex(gameDataList: any) {
    return this.http.post(this._apiURLMobile + '/save-or-update-user-added-game-with-complex', gameDataList);
  }
  getExistingComplexByComplexInfo(complex: any) {
    return this.http.post(this._apiURLMobile + '/get-existing-complex-by-complex-info', complex);
  }
  sendEmailToAddAnEvent(eventData: any) {
    return this.httpService.post(this._api + '/send-email-to-add-player-event', eventData);
  }
  // END Add Non TGS Game

  // END My Team Schedules

  //Event Details
  getTeamEventData(eventID: number, teamID: number) {
    return this.httpService.get(this._api + '/get-team-single-event-details-by-eventId/' + eventID + '/' + teamID);
  }
  getEventDirectorList(eventID: number) {
    return this.httpService.get(this._api + '/get-event-director-detail-list/' + eventID);
  }
  sendEmailToDirector(directorData: any) {
    return this.httpService.post(this._api + '/send-email-to-director', directorData);
  }

  //Register to an Event
  getDivisionListByEventID(eventID: number, gender: string) {
    return this.httpService.get(this._api + '/get-division-list/' + eventID + '/' + gender);
  }
  getFlightRequestList() {
    return this.httpService.get(this._api + '/get-flight-request-data');
  }
  getFlightRequestDataByEventID(eventID: number) {
    return this.httpService.get(this._api + '/get-flight-request-data-by-eventID/' + eventID);
  }
  getCoachListByTeamID(teamID: number, eventID: number) {
    return this.httpService.get(this._api + '/get-coachlist-by-teamID/' + teamID + '/' + eventID);
  }
  getRegisteredStaffInfo(emailID: string) {
    return this.httpService.get(this._api + '/get-registered-staff-info/' + emailID);
  }
  registerTeamToAnEvent(registerData: any) {
    return this.httpService.post(this._api + '/register-team-to-event', registerData);
  }
  teamEventRegistrationTermsAgreementSigned(data: any) {
    return this.httpService.post(this._api + '/team-event-registration-terms-agreement-signed', data);
  }
  teamEventRegistrationTermsAgreementSignedDetails(data: any) {
    return this.httpService.post(this._api + '/team-event-registration-terms-agreement-signed-details', data);
  }
  registerOrUpdateStaffData(staffData: any) {
    return this.httpService.post(this._api + '/register-or-update-staff-data', staffData);
  }
  saveOrUpdateStaffMatchRoster(staffData: any) {
    return this.httpService.post(this._api + '/save-or-update-staff-match-roster', staffData);
  }
  removeAndReplaceStaffRoster(staffData: any) {
    return this.httpService.post(this._api + '/remove-and-replace-staff-roster', staffData);
  }
  //END Register to an Event

  //END Event Details

  //Event Payment
  getEventPaymentData(eventID: number, teamID: number) {
    return this.httpService.get(this._api + '/get-event-payment-page-data/' + eventID + '/' + teamID)
  }
  getCardListByUserID(userID: number) {
    return this.httpService.get(this._apiPlayer + '/getSavedCardsDetails/' + userID);
  }
  getUserCardListAndCheckIsSavedForTeamEventRegistration(userID: number, teamID: number, eventID: number) {
    return this.httpService.get(this._api + '/get-usercard-list-and-check-is-saved-for-teameventregistration/' + userID + '/' + teamID + '/' + eventID);
  }
  deleteCard(userID: number, cardId: number) {
    return this.httpService.delete(this._apiClubParent + '/removeUserCardInfo/' + userID + '/' + cardId);
  }
  addNewCard(cardData: any) {
    return this.httpService.post(this._apiClubParent + '/addNewCard', cardData);
  }
  submitMyCardWhenTeamApproved(cardData: any) {
    return this.httpService.post(this._api + '/submit-my-card-when-team-approved', cardData);
  }
  eventPaymentChargeMyCard(cardData: any) {
    return this.httpService.post(this._api + '/event-payment-charge-my-card', cardData);
  }
  submitMailInPayment(mailData: any) {
    return this.httpService.post(this._api + '/submit-mail-in-check-payment-team', mailData);
  }
  submitMailInPaymentNew(mailData: any) {
    return this.httpService.post(this._api + '/submit-mail-in-check-payment-team-new', mailData);
  }
  //END Event Payment

  //Event Online Check-In
  isOnlineCheckInEnabled(eventID: number) {
    return this.httpService.get(this._api + '/get-is-online-checkin-enabled/' + eventID);
  }
  getEventCheckInTeamRequiredItemsData(eventID: number, teamID: number) {
    return this.httpService.get(this._api + '/get-event-player-checkIn-team-required-items-data-by-eventID-and-teamID/' + eventID + '/' + teamID);
  }
  validatePlayersBeforeSubmittingDocumentsForReview(payload: any) {
    return this.httpService.post(this._api + '/validate-players-before-submitting-documents-for-review', payload);
  }
  submitPaymentForPlayerCheckin(payload: any) {
    return this.httpService.post(this._api + '/submit-payment-for-player-checkin', payload);
  }
  getEventPlayerCheckInRequiredItemsData(eventID: number, playerID: number, teamID: number) {
    return this.httpService.get(this._api + '/get-event-player-checkIn-required-items-data-By-eventID-and-playerID/' + eventID + '/' + playerID + '/' + teamID);
  }
  getEventPlayerCheckinData(eventID: number, teamID: number, divisionID: number = 0) {
    return this.httpService.get(this._api + '/get-player-check-in-data-by-eventID-and-teamID/' + eventID + '/' + teamID + '?divisionID=' + divisionID);
  }
  getEventPlayerPaymentInfoForClubAndTeam(eventID: number, teamID: number) {
    return this.httpService.get(this._apiEvent + '/get-event-player-payment-info-for-club-and-team/' + eventID + '/' + teamID);
  }

  removeFileFromS3(files: string[]) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      }),
      body: {
        playerFormPathList: files
      }
    };
    return this.http.delete(this._apiPlayer + '/removeFilesFromS3', httpOptions);
  }

  savePlayerUploadedFile(fileData: any) {
    return this.httpService.post(this._api + `/save-player-uploaded-file`, fileData);
  }

  saveTeamUploadedFile(fileData: any) {
    return this.httpService.post(this._api + `/save-team-form`, fileData);
  }

  submitDocumentsForReview(reviewData: any) {
    return this.httpService.post(this._api + '/submit-documents-for-review', reviewData);
  }

  savePlayerMissingInfo(payload: any) {
    return this.httpService.post(this._api + '/save-player-missing-info', payload);
  }

  saveOrUpdateEventPlayerForm(eventID: number, playerFormIDOld: number, playerFormIDNew: number) {
    playerFormIDOld = playerFormIDOld > 0 ? playerFormIDOld : 0;
    playerFormIDNew = playerFormIDNew > 0 ? playerFormIDNew : 0;
    return this.httpService.post(this._api + '/save-or-update-event-player-form/' + eventID + '/' + playerFormIDOld + '/' + playerFormIDNew);
  }

  getPlayerFormByPlayerID(playerID: number, clubID: number) {
    return this.httpService.get(this._apiPlayer + '/get-player-form-by-playerID/' + playerID + '/' + clubID);
  }
  //END Event Online Check - In

  //Event Roster
  getEventRosterData(eventID: number, teamID: number) {
    return this.httpService.get(this._api + '/get-event-roster-data/' + eventID + '/' + teamID);
  }

  getClubTeamOrgRosterList(clubID: number, teamID: number, eventID: number, matchID: number) {
    return this.httpService.get(this._api + '/get-club-team-org-roster-list/' + clubID + '/' + teamID + '/' + eventID + '/' + matchID);
  }

  getEventMatchList(eventID: number, teamID: number) {
    return this.httpService.get(this._api + '/get-event-match-list/' + teamID + '/' + eventID);
  }

  getMatchRosterData(eventID: number, teamID: number, matchID: number) {
    return this.httpService.get(this._api + '/get-single-match-with-roster-data/' + eventID + '/' + teamID + '/' + matchID);
  }

  getEventStaffRosterData(eventID: number, teamID: number, matchID: number) {
    return this.httpService.get(this._api + '/get-staff-roster-list/' + teamID + '/' + eventID + '/' + matchID);
  }

  getEventLineUpPlayerList(eventID: number, teamID: number, matchID: number) {
    return this.httpService.get(this._api + '/get-line-up-player-list/' + teamID + '/' + eventID + '/' + matchID);
  }

  getApprovedTeamStaffListByTeamIDAndEventID(teamID: number, eventID: number, roleID: number) {
    return this.httpService.get(this._api + '/get-approved-team-staff-list-by-teamID-and-eventID/' + teamID + '/' + eventID + '/' + roleID);
  }

  getTeamStaffList(eventID: number, teamID: number, matchID: number) {
    return this.httpService.get(this._api + '/get-team-staff-list-by-teamId-eventId/' + teamID + '/' + eventID + '/' + matchID);
  }

  getApprovedHeadCoachListByTeamIDAndEventID(teamID: number, eventID: number) {
    return this.httpService.get(this._api + '/get-approved-head-coach-list-by-teamID-and-eventID/' + teamID + '/' + eventID);
  }

  getHeadCoachListByTeam(teamID: number) {
    return this.httpService.get(this._api + '/get-head-coach-list-by-teamID/' + teamID);
  }

  getTeamSpotsByTeamID(teamID: number) {
    return this.httpService.get(this._api + '/get-team-spots-by-teamID/' + teamID);
  }

  getDivisionMinAndMaxAndAvailableRosterSpots(teamID: number, matchID: number) {
    return this.httpService.get(this._api + '/get-division-min-and-max-and-available-roster-spots/' + teamID + '/' + matchID);
  }

  addPlayerRoster(data: any) {
    return this.httpService.post(this._api + `/add-player-to-game`, data);
  }

  assignOrgPlayerToMatchRoster(data: any) {
    return this.httpService.post(this._api + `/assign-org-player-to-match-roster`, data);
  }

  updateJerseryNumberForEventRoster(jerseryData: any) {
    return this.httpService.post(this._api + `/update-player-jersey-number-for-event-roster`, jerseryData);
  }

  removeTeamEventRoster(teamID: number, eventID: number, userID: number) {
    return this.httpService.delete(`${this._api}/remove-player-from-team-event-roster/${teamID}/${eventID}/${userID}`);
  }

  assignUserToEventStaffRoster(userID: number, teamID: number, eventID: number, roleID: number) {
    return this.httpService.post(this._api + `/assign-user-to-event-staff-roster/${userID}/${teamID}/${eventID}/${roleID}`);
  }

  assignUserToMatchRoster(matchRosterData: any) {
    return this.httpService.post(this._api + `/assign-user-to-match-roster`, matchRosterData);
  }

  assignUserToStaffMatchRoster(matchRosterData: any) {
    return this.httpService.post(this._api + `/assign-user-to-staff-match-roster`, matchRosterData);
  }

  removeUserFromEventStaffRoster(teamID: number, eventID: number, userID: number) {
    return this.httpService.delete(`${this._api}/remove-user-from-event-staff-roster/${teamID}/${eventID}/${userID}`);
  }

  removeUserFromMatchRoster(matchID: number, teamID: number, userID: number) {
    return this.httpService.delete(`${this._api}/remove-user-from-match-roster/${matchID}/${teamID}/${userID}`);
  }

  removeUserFromStaffMatchRoster(matchID: number, teamID: number, userID: number) {
    return this.httpService.delete(`${this._api}/delete-user-from-staff-match-roster/${matchID}/${teamID}/${userID}`);
  }

  //END Event Roster

  //Event Documents
  getTeamEventDocuments(teamID: number, eventID: number) {
    return this.httpService.get(this._api + '/get-team-event-documents/' + teamID + '/' + eventID);
  }
  getEventPlayerCheckinPaymentReport(payload) {
    return this.http.post(this._api + '/get-event-player-checkin-payment-report', payload);
  }
  printEventPlayerCheckinPaymentReciept(payload) {
    return this.http.post(this._api + '/print-event-player-checkin-payment-reciept', payload);
  }
  //END Event Documents

  //Event Application Request
  getAppReqQuestionsAndAnswers(eventID: number, teamID: number) {
    return this.httpService.get(this._api + '/get-standard-questions-and-additional-info/' + eventID + '/' + teamID);
  }
  getAppReqStaffList(eventID: number) {
    return this.httpService.get(this._api + '/get-event-director-detail-list/' + eventID);
  }
  sendApplicationRequestMessage(emailData: any) {
    return this.httpService.post(this._api + '/send-application-request-message', emailData);
  }
  //END Event Application Request

  //Event Terms and Conditions
  getEventTermsAndConditions(teamID: number, eventID: number) {
    return this.httpService.get(this._api + '/get-event-agreement/' + teamID + '/' + eventID);
  }
  public getIPAddress() {
    return this.http.get("https://cors-anywhere.herokuapp.com/https://api.ipify.org/?format=json");
  }
  updateTeamEventAgreement(agreementData: any) {
    return this.httpService.post(this._api + '/update-team-event-agreement', agreementData);
  }
  //END Event Terms and Conditions

  //Team Statistics-> New api: [HttpGet("get-team-statistics-non-tgs-game-details/{gameID}")]

  getTeamStatisticsGameHistoryAndCounts(teamID: number, year: number) {
    return this.httpService.get(this._api + '/get-team-statistics-game-history-and-counts/' + teamID + '/' + year);
  }
  getEventSettings(eventID: number) {
    return this.httpService.get(this._apiEvent + '/get-event-settings/' + eventID);
  }
  getTeamStatisticsGameDetails(teamID: number, eventID: number, matchID: number) {
    return this.httpService.get(this._api + '/get-team-statistics-game-details/' + teamID + '/' + eventID + '/' + matchID);
  }
  getTeamStatisticsNonTgsGameDetails(matchID: number) {
    return this.httpService.get(this._api + '/get-team-statistics-non-tgs-game-details/' + matchID);
  }
  saveOrUpdatePlayerStats(data: any) {
    return this.http.post(this._api + '/save-or-update-player-statistic', data);
  }
  saveOrUpdatePlayerStatsForNonTgsGame(data: any) {
    return this.httpService.post(this._api + '/save-or-update-player-stats-for-non-tgs-game', data);
  }
  updateTeamStandings(data: any) {
    return this.httpService.post(this._api + '/update-team-standings', data);
  }
  saveOrUpdateMatchGoalStatistics(payload: any) {
    return this.httpService.post(this._apiURLMobile + '/save-or-update-match-goal-statistics', payload);
  }
  getUserGameDocuments(matchID: number, matchDate: any) {
    return this.httpService.get(this._api + '/get-user-game-documents/' + matchID + '/' + matchDate);
  }
  getTopScorerData(teamID: number, year: number, flag: string, matchID: number) {
    return this.httpService.get(this._api + '/get-top-scorer-data/' + teamID + '/' + year + '/' + flag + '/' + matchID);
  }
  getTeamStatisticsGameHistoryByPlayer(teamID: number, year: number, playerID: number, positionID: number, flag: string) {
    return this.httpService.get(this._api + '/get-team-statistics-game-history-by-player/' + teamID + '/' + year + '/' + playerID + '/' + positionID + '/' + flag);
  }
  saveUploadedReportPath(reportData: any) {
    return this.httpService.post(this._api + '/save-uploaded-report-path', reportData);
  }
  //END Team Statistics

  //Team College Center
  getIsActiveTeamAllInOneProgram(teamID: number) {
    return this.httpService.get(this._api + `/get-is-active-team-all-in-one-program/${teamID}`);
  }
  getTeamCollegeCenterDashboardData(teamID: number) {
    return this.httpService.get(this._api + `/get-team-college-center-dashboard-data/${teamID}`);
  }
  //END Team College Center

  //By Individual Event
  getTeamEventGameHistoryByTeamEvent(teamID: number, eventID: number) {
    return this.httpService.get(this._api + '/get-team-event-game-history-by-team-event/' + teamID + '/' + eventID);
  }
  //END By Individual Event

  //Team Player
  removePlayerFromTeamByAdmin(playerID: number, teamID: number, adminUserID: number) {
    return this.httpService.delete(`${this._apiPlayer}/remove-player-from-team-by-admin/${playerID}/${teamID}/${adminUserID}`);
  }
  //End Team Staff

  //Team Staff
  deleteTeamStaff(teamID: number, userID: number) {
    return this.httpService.delete(`${this._api}/delete-team-staff/${teamID}/${userID}`);
  }
  //End Team Staff

  //College Center Commitment
  getCollegeCenterCommitmentDeatils(teamID: number, flag: number) {
    return this.http.get(this._apiUrl + '/get-team-college-commitments/' + teamID + '/' + flag);
  }

  //Player Mood
  getplayerMood(teamID: number, date: string) {
    return this.http.get('/api/Mood/get-team-player-mood-statistics/' + teamID + '/' + date);
  }

  getMonthlyMoodData(teamID: number, startDate: string, endDate: string) {
    return this.http.get('/api/Mood/get-team-monthly-mood-statistics/' + teamID + '/' + startDate + '/' + endDate);
  }

  //Game Survey
  getGameSurveyData(teamID: number) {
    return this.http.get(this._api + '/get-game-survey-dashboard-data/' + teamID);
  }

  getGameIndividualSurvey(teamID: number, matchID: number) {
    return this.http.get(this._api + '/get-player-game-survey-data/' + teamID + '/' + matchID);
  }

  getTeamType() {
    return this.http.get(this._api + '/get-team-type');
  }

  printEntirePlayerPoolPemphlet(obj: any) {
    return this.http.post(this._api + '/print-entire-player-pool-pemphlet', obj);
  }

  printEventPamphlet(obj: any) {
    return this.http.post(this._api + '/print-pemphlet-by-event', obj);
  }

  printGamePamphlet(obj: any) {
    return this.http.post(this._api + '/print-pemphlet-by-game', obj);
  }

  getEventGameList(teamID: number, eventID: number) {
    return this.httpService.get('/api/Event/get-event-matches/' + teamID + '/' + eventID);
  }

  sendEmailToRequestReciprocalDeal(directorData: any) {
    return this.httpService.post(this._apiEvent + '/send-email-to-request-reciprocal-deal', directorData);
  }

  getTeamPractices(teamID: number) {
    return this.httpService.get(this._api + '/get-team-practices/' + teamID);
  }

  getPracticePlayerListByStatus(attendingStatusID: number, practiceID: number) {
    return this.httpService.get(this._api + '/get-practice-player-list-by-status/' + attendingStatusID + '/' + practiceID);
  }

  getOtherEventPlayerListByStatus(attendingStatusID: number, practiceID: number) {
    return this.httpService.get(this._api + '/get-other-event-player-list-by-status/' + attendingStatusID + '/' + practiceID);
  }

  addOrEditPracticeToTeamOrClub(obj: any) {
    if (obj.PracticeId > 0) {
      return this.http.post(this._api + '/edit-practice-for-team', obj);
    } else {
      return this.http.post(this._api + '/add-practice-to-team-or-club', obj);
    }
  }

  addOrEditPracticeToTeamOrClubNew(obj: any) {
    if (obj.PracticeId > 0) {
      return this.http.post(this._api + '/edit-practice-for-team', obj);
    } else {
      return this.http.post(this._api + '/add-practice-to-team-or-club-with-email-send', obj);
    }
  }

  getComplexVenueByClubID(clubID: number) {
    return this.httpService.get(this._api + '/get-complex-venue-by-clubID/' + clubID);
  }

  saveUserPracticeAttendingStatus(obj: any) {
    return this.http.post(this._api + '/save-user-practice-attending-status', obj);
  }


  saveUserOtherEventAttendingStatus(obj: any) {
    return this.http.post(this._api + '/save-user-other-event-attending-status', obj);
  }

  deleteOtherEventNew(obj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      }),
      body: {
        OtherEventIDList: obj.OtherEventIDList,
        FlagForDelete: obj.FlagForDelete,
        IsRepeat: obj.IsRepeat,
        EventNotificationIDs: obj.EventNotificationIDs,
        AddedBy: obj.AddedBy
      }
    };
    return this.http.delete(this._api + '/delete-other-event-new', httpOptions);
  }
  deletePastOtherEventForTeam(obj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      }),
      body: {
        OtherEventIDList: obj.OtherEventIDList,
        TeamID: obj.TeamID
      }
    };
    return this.http.delete(this._api + '/delete-past-other-event-for-team', httpOptions);
  }
  removePractice(obj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      }),
      body: {
        PracticeIDList: obj.PracticeIDList,
        FlagForDelete: obj.FlagForDelete,
        AddedBy: obj.AddedBy,
        IsRepeat: obj.IsRepeat,
        PracticeNotificationIDs: obj.PracticeNotificationIDs
      }
    };
    return this.http.delete(this._api + '/delete-practice-for-team', httpOptions);
  }
  deletePastPracticeForTeam(obj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      }),
      body: {
        PracticeIDList: obj.PracticeIDList,
        TeamID: obj.TeamID,
      }
    };
    return this.http.delete(this._api + '/delete-past-practice-for-team', httpOptions);
  }
  removeUserAddedGame(obj: any) {
    return this.http.request(
      'delete',
      this._apiURLMobile + '/remove-user-added-game/',
      { body: obj.matchID }
    );

  }
  sendEmailToPlayersForActive(data: any) {
    return this.httpService.postRaw(`${this._api}/${'send-email-to-players-for-active'}`, data);
  }

  getUpcomingGamesForTeamCalender(teamID: number) {
    return this.httpService.get(this._api + '/get-upcoming-games-for-team-calender/' + teamID);
  }
  getDataForTeamDashboardCalender(teamID: number) {
    return this.httpService.get(this._api + '/get-data-for-team-dashboard-calender/' + teamID);
  }
  getOtherEventsInfo(teamID: number) {
    return this.httpService.get(this._api + '/get-other-events-info/' + teamID);
  }

  removeEvent(obj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      }),
      body: {
        OtherEventIDList: obj.OtherEventIDList,
        TeamName: obj.teamName,
        ClubLogo: obj.clubLogo,
        Invitedplayers: obj.Invitedplayers,
        IsRepeat: obj.isRepeat
      }
    };
    return this.http.delete(this._api + '/delete-other-event', httpOptions);
  }

  addOrEditOtherEventsToTeam(obj: any) {
    if (obj.OtherEventID > 0) {
      return this.http.post(this._api + '/edit-other-event-data', obj);
    } else {
      return this.http.post(this._api + '/add-other-events-to-team', obj);
    }
  }

  getOtherEventLocationList() {
    return this.httpService.get(this._api + '/get-other-event-location-list');
  }

  getVenueListByComplexID(complexID: number, eventID: number) {
    return this.httpService.get(this._apiPlayer + '/get-venue-list-by-complexID/' + complexID + '/' + eventID);
  }

  getClubTeamComplexList(clubID: number, teamID: number) {
    return this.httpService.get(this._apiURLMobile + '/get-club-team-complex-list/' + clubID + '/' + teamID);
  }

  getIndividualTeamInfoByTeam(teamID: number) {
    return this.httpService.get(this._api + '/get-individual-team-info-by-team/' + teamID);
  }

  getStates(): Observable<StateList[]> {
    return this.http.get<StateList[]>('api/State');
  }

  getClubListByStateID(stateID: number) {
    return this.httpService.get(this._clubUrl + '/get-club-list-by-stateID/' + stateID);
  }

  editTeamInformation(obj: any) {
    return this.http.post(this._api + '/edit-team-information', obj);
  }

  updateParentPassword(pwd: { OldPassword: string, NewPassword: string, UserID: string }) {
    return this.http.post<any>(this._apiClubParent + '/updateParentUserPassword', pwd);
  }
  notify(msg: string, type: string) {
    this.notifyService.html(msg, NotificationType[type], { pauseOnHover: true, clickToClose: true, showProgressBar: false });
  }

  getTeamGameVideoRequestListByTeamID(teamID: number) {
    return this.httpService.get(this._api + '/get-team-game-video-request-list-by-team-id/' + teamID);
  }

  isPracticeEnableByClub(teamID: number) {
    return this.httpService.get(this._api + '/is-practice-enable-by-club/' + teamID);
  }

  getMatchGoalAssistPlayerList(data: any) {
    return this.http.post(this._apiURLMobile + '/get-match-goal-assist-player-list', data);
  }

  getGameCommentaryByMatchID(data: any) {
    return this.http.post(this._apiURLMobile + '/get-game-commentary-by-matchID', data);
  }

  getMatchCommentaryHistoryList(matchID: number, teamID: number) {
    return this.http.get(this._apiURLMobile + '/get-match-commentary-history-list/' + matchID + '/' + teamID);
  }

  getMatchCommentaryHistoryListByMatchIDTeamID(matchID: number, teamID: number) {
    return this.http.get(this._apiURLMobile + '/get-match-commentary-history-by-matchID-teamID/' + matchID + '/' + teamID);
  }

  getPlayerListForTGSAndUserAddedGame(teamID: number, eventID: number, matchID: number, isUserAddedGame: boolean) {
    return this.httpService.get(this._apiURLMobile + '/get-player-list-for-tgs-and-user-game/' + teamID + '/' + eventID + '/' + matchID + '/' + isUserAddedGame);
  }

  getTeamMatchReport(teamID: number, matchID: number, isUserAddedGame: boolean) {
    return this.httpService.get(this._apiURLMobile + '/get-team-match-report/' + teamID + '/' + matchID + '/' + isUserAddedGame);
  }

  saveOrUpdateTeamMatchStat(obj: any) {
    return this.http.post(this._apiURLMobile + '/save-or-update-team-match-stat', obj);
  }

  getGoalKeeperListForTGSAndUserGame(teamID: number, eventID: number, matchID: number, isUserAddedGame: boolean) {
    return this.httpService.get(this._apiURLMobile + '/get-goal-keeper-list-for-tgs-and-user-game/' + teamID + '/' + eventID + '/' + matchID + '/' + isUserAddedGame);
  }

  saveOrUpdateSaveMadeForGoalKeeper(obj: any) {
    return this.http.post(this._apiURLMobile + '/save-or-update-save-made-for-goal-keeper', obj);
  }
  saveOrUpdatePlayerMatchStatisticsInfo(payload: any) {
    return this.http.post(this._apiURLMobile + '/save-or-update-player-match-statistics-info', payload);
  }
  getSetPiece(clubID: number, teamID: number, matchID: number) {
    return this.httpService.get(`${this._apiGame}/get-set-piece/${clubID}/${teamID}/${matchID}`);
  }

  getEventTeamDetails(teamID: number, eventID: number) {
    return this.httpService.get(`${this._apiEvent}/get-event-team-details/${eventID}/${teamID}`)
  }

  getEventTeamQuestionsAnswers(teamID: number, eventID: number) {
    return this.httpService.get(`${this._api}/get-applications-questions-answers/${eventID}/${teamID}`);
  }

  updateEventTeamQuestionsAnswers(teamID: number, eventID: number, data) {
    return this.httpService.post(`${this._api}/update-applications-questions-answers/${eventID}/${teamID}`, data, { params: { addedBy: StorageUtil.userID } });
  }

  getTGSRepresentativeList() {
    return this.httpService.get(this._apiMasterBackend + "/get-tgs-representative-list");
  }

  getTeamParentsList(teamID) {
    return this.httpService.get(this._api + "/get-team-parents/" + teamID);
  }

  getTeamMostCommonMood(teamID) {
    return this.httpService.get("/api/DevelopmentCalendar/team-most-common-mood/" + teamID);    
  }
}



// WEBPACK FOOTER //
// ./src/app/services/my-teams.service.ts